interface GetHasMetaProps {
	available: boolean
	withArrow: boolean
	lastUnits?: true
}
export function getHasMeta({
	available,
	withArrow,
	lastUnits,
}: GetHasMetaProps): boolean {
	return !available || lastUnits || withArrow
}
